import { Stack } from '@mui/material';
import { ISuppliersResource } from 'API/Suppliers/suppliers';
import { CheckboxInput } from 'Components';
import { SuppliersContext } from 'Context/SuppliersContext';
import { useContext } from 'react';
import { ResetFilterButtons } from '../../ResetFilterButtons';
import { checkboxHandler } from 'Utils/supplierFilterManager';
import { SUPPLIER_RESULT_FILTER } from 'Enum/suppliers';

export const Training = () => {
  const { resources, filters, setFilters, dispatchSuppliers } =
    useContext(SuppliersContext);

  const resetTreatMethodsCheckboxes = () => {
    const degree: number[] = [];
    setFilters({ ...filters, degree });
  };

  return (
    <Stack
      sx={{
        pb: '50px',
      }}
    >
      {resources?.TOARA?.resources?.map(
        (training: ISuppliersResource, index: number) => {
          const isChecked =
            filters.degree?.some(
              (degreeId) => degreeId === training.resourceId
            ) || false;
          return (
            <CheckboxInput
              key={index}
              checked={isChecked}
              label={training.content}
              onChange={() => {
                const degree = checkboxHandler(
                  filters.degree,
                  training.resourceId
                );
                setFilters({ ...filters, degree });
              }}
              containerStyle={{
                '.MuiCheckbox-root': {
                  m: '8px 0',
                  p: '0 5px 0 16px',
                },
              }}
              textSx={{
                fontWeight: isChecked ? '600 !important' : undefined,
                ':hover': {
                  fontWeight: 600,
                },
              }}
            />
          );
        }
      )}
      <ResetFilterButtons
        resetCallback={() => resetTreatMethodsCheckboxes()}
        filterCallback={() => {
          dispatchSuppliers({
            type: SUPPLIER_RESULT_FILTER.Therapy,
            payload: { value: filters },
          });
        }}
      />
    </Stack>
  );
};
